import classNames from 'classnames';
import * as PropTypes from 'prop-types';
import React, { useState } from 'react';
import Icon, { Icons } from '../Icon/Icon';
import Input from '../Input';

import './PasswordInput.scss';

const EYE_ICON_SIZE = 20;

const PasswordInput = ({ className = '', postfix = null, ...props }) => {
	const [type, setType] = useState('password');

	const toggleEye = () => {
		setType(type => (type === 'password' ? 'text' : 'password'));
	};

	const eyeButton = (
		<button className='PasswordInput__eye-button' onClick={toggleEye}>
			<Icon
				type={Icons[type === 'password' ? 'EYE_SLASH' : 'EYE_ICON']}
				className='PasswordInput__eye'
				width={EYE_ICON_SIZE}
				height={EYE_ICON_SIZE}
			/>
		</button>
	);

	const postfixElement = (
		<>
			{postfix}
			{eyeButton}
		</>
	);

	return <Input className={classNames('PasswordInput', className)} type={type} postfix={postfixElement} {...props} />;
};

Input.propTypes = {
	className: PropTypes.string,
	postfix: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

export default PasswordInput;
